import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import Address from '../../components/Address/Address';
import { ProductCard } from '../../flayr-components';
import Distance from '../../lib/Distance/Distance';
import ProvidersList from '../../pages/customerPages/QuotePage/components/ProvidersList/ProvidersList';
import { IOffer } from '../../types/quote/offer';

interface IOtherOffersSectionProps {
  offers: IOffer[];
}

const OtherOffersSection: React.FC<React.PropsWithChildren<IOtherOffersSectionProps>> = ({ offers }) => {
  if (!offers.length) {
    return null;
  }
  return (
    <div
      className={`bg-[#FFDECE] py-8 px-5 lg:px-12 lg:py-20 text-gray-primary`}
    >
      <h2 className="text-lg lg:text-4xl font-medium !leading-[1.2em] mb-5 lg:mb-8">
        Other Offers
      </h2>
      <ul className="flex w-full space-x-3 overflow-x-auto flex-nowrap">
        {/* <ProvidersList horizontal items={[...offers, ...offers]} /> */}
        {offers.map(({ offer, provider }, index) => (
          <li
            key={index}
            className="flex-none w-3/5 md:w-4/12 lg:w-9/12 xl:w-5/12"
          >
            <ListItem offer={offer} provider={provider} />
          </li>
        ))}
      </ul>
    </div>
  );
};
export default OtherOffersSection;

const statusLabelMapping = {
  bookedOut: 'unavailable',
  declined: 'unavailable',
  expired: 'unavailable',
  dismissed: 'unavailable',
  booked: 'booked',
  requested: 'requested',
  offered: 'offered',
  timeChangeRequested: 'offered',
  cancelled: 'cancelled',
  cancelledByProvider: 'cancelled',
  cancelledByFlayr: 'cancelled',
  cancelledByCustomer: 'cancelled',
  rescheduleRequested: 'booked',
  rescheduleOffered: 'booked',
};
function ListItem({
  offer,
  // search = undefined,
  provider,
  // url,
  hideReviews = false,
  className = '',
  hideRecommendedLabel = false,
  filterBy = '',
}) {
  let url = `/offers/${offer.id}/`;
  if (offer.key) {
    url += offer.key;
  }

  const coverImg =
    (filterBy && provider.albumCovers?.[filterBy]) || provider.coverPhoto;

  return (
    <Link
      to={{
        pathname: url,
        state: {
          provider,
        },
        search: `?mobileOrStudio=${offer?.location.mobileOrStudio}`,
      }}
      className={classNames(
        'flex items-stretch flex-none self-stretch',
        className,
        {
          'pointer-events-none': offer?.status === 'bookedOut',
        }
      )}
    >
      <ProductCard
        name={provider.name}
        coverImg={coverImg}
        vaccinated={provider.isVaccinated}
        deposit={offer?.pricing?.amount}
        coverText="View"
        overlay
        depositAltContent={
          (offer?.location?.mobileOrStudio === 'mobile' && (
            <div>
              <span className="text-xs">
                Including travel to you in{' '}
                <Address minimal address={offer.location.addressFull} />
              </span>
            </div>
          )) ||
          (offer?.location.mobileOrStudio === 'studio' && (
            <div className="text-xs">
              <div className="">
                <Address minimal address={offer.location.addressFull} />
              </div>
              Distance:{' '}
              <Distance
                distanceInMeters={offer?.location.distance.inMeters}
                unit={offer?.location.distance.unit}
              />
            </div>
          )) ||
          null
        }
        price={offer?.pricing.totalPostCredits}
        profileImg={provider.photo}
        status={
          (offer?.status && statusLabelMapping[offer.status]) || undefined
        }
        rating={provider.review?.averageScore}
        totalReviews={provider.review?.totalCount}
        shadow
        avatarStaticResponsiveImgSize={64}
        responsiveCoverImg
        hideReview={hideReviews}
        coverImgAspectRatio={1.2}
        featured={provider.isFeatured && !hideRecommendedLabel}
        currency={offer?.pricing?.currencySymbol}
      />
    </Link>
  );
}
